module.exports = __webpack_public_path__ + "img/D202204_4.ec7dc528.jpg";